export default "__VITE_ASSET__Dlb8WM4N__"